import * as navTabs from '@/utils/templates/mqTemplate/mq.constants';
import amqOverviewGraphs from '@/utils/templates/mqTemplate/amq.overview.graphs.config';
import { messageQueueTypes } from '@/components/MQ/mq.types';
import { kafkaOverviewSingleGraphs } from '@/utils/templates/mqTemplate/kafka.overview.graphs.config';

const mq = {
  [messageQueueTypes.amq]: {
    [navTabs.NAVTAB_AMQ_KEY.OVERVIEW]: [
      amqOverviewGraphs().memory.lineCharts,
      amqOverviewGraphs().queue.lineCharts,
    ],
  },
  [messageQueueTypes.kafka]: {
    [navTabs.KAFKA_OVERVIEW_TAB_KEY.BROKER]: [
      kafkaOverviewSingleGraphs()['kafka-overview-broker'],
    ],
    [navTabs.KAFKA_OVERVIEW_TAB_KEY.PRODUCER]: [
      kafkaOverviewSingleGraphs()['kafka-overview-producer'],
    ],
    [navTabs.KAFKA_OVERVIEW_TAB_KEY.CONSUMER]: [
      kafkaOverviewSingleGraphs()['kafka-overview-consumer'],
    ],
  },
};

export default mq;
